import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinvimannagar() {



    const cardData = {

keyword: "Cab Service in Viman Nagar",

headingDescription:
    "Rising Cab Service offers reliable and affordable Cab Service in Viman Nagar for airport travelers, IT professionals, families, and daily commuters. We provide quick local rides, Pune Airport transfers, railway station drops, and comfortable outstation travel from Viman Nagar to all major destinations. Our fleet includes well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by professional and verified chauffeurs. With 24/7 availability, on-time pickup, and transparent pricing, Rising Cab Service ensures a safe, smooth, and hassle-free travel experience in Viman Nagar and nearby areas.",

topPlaces: [
   
   {
        title: "Bhimashankar",
        description:
            " combines spiritual importance with natural beauty, located deep within the Western Ghats. The temple attracts pilgrims while surrounding forests provide trekking routes and wildlife sightings. Its peaceful environment makes it both a religious and nature-friendly destination."
    },
     {
        title: "Mahabaleshwar",
        description:
            " draws tourists with its cool climate, dense forests, and breathtaking viewpoints across the Western Ghats. Strawberry farms, waterfalls, and boating spots enhance the overall hill-station experience. The region offers a perfect mix of nature, sightseeing, and relaxed holiday vibes."
    },
    {
        title: "Panchgani",
        description:
            " offers a calm hill-station experience centered around the vast Table Land plateau and scenic valley views. Strawberry farms, colonial-era charm, and pleasant weather create a peaceful environment for families and couples. Its slower pace makes it ideal for unwinding away from city life."
    },
    {
        title: "Alibaug",
        description:
            " brings a coastal escape with clean beaches, historic sea forts, and refreshing sea breeze experiences. Ferry rides and beachside activities add adventure and fun to short trips from Pune. Fresh seafood and sunset views enhance the relaxed coastal atmosphere."
    },
    {
        title: "Matheran",
        description:
            " provides a unique pollution-free hill retreat where vehicles are completely banned, preserving its natural charm. Dense forests, toy train rides, and multiple viewpoints offer scenic walking trails throughout the region. Its quiet surroundings make it perfect for slow, nature-focused travel."
    },
     {
        title: "Lonavala",
        description:
            " stands out as one of the most visited weekend escapes from Pune, surrounded by lush valleys, waterfalls, and misty hills. Monsoon season transforms the entire region into a green paradise, making it ideal for nature walks, short treks, and photography. Local attractions, caves, and famous chikki shops add to the overall travel experience."
    },
    {
        title: "Khandala",
        description:
            " attracts travelers with its dramatic cliffs, foggy mountains, and iconic viewpoints such as Tiger’s Leap. Located close to Lonavala, it offers quick road-trip access from Pune for a refreshing break. Scenic drives, monsoon landscapes, and peaceful hill views make it a favorite among weekend explorers."
    },
    {
        title: "Lavasa",
        description:
            " features a planned lakeside township designed with colorful architecture inspired by European towns. Visitors enjoy relaxed walks along the promenade, boating activities, and resort stays surrounded by hills. Its calm environment makes it suitable for family outings and short leisure trips from Pune."
    },
    
    {
        title: "Tapola",
        description:
            " offers a quiet lakeside escape often called the Mini Kashmir of Maharashtra, surrounded by calm waters and green hills. Boating, camping, and photography are popular activities in this serene environment. Its less crowded nature makes it perfect for peaceful weekend retreats."
    },
    {
        title: "Kolad",
        description:
            " delivers an adventure-packed experience centered around white-water rafting on the Kundalika River. Monsoon season boosts water levels, making it a hotspot for thrill-seekers and group trips. Camping, kayaking, and riverside stays complete the outdoor adventure feel."
    }
],



services: [
    {
        name: "Taxi Service in Viman Nagar",
        description:
            "Rising Cab Service offers Taxi Service in Viman Nagar for residents, corporate employees, students, and travelers looking for safe, reliable, and comfortable transportation. We provide well-maintained AC cars, experienced drivers, and 24x7 availability for local travel, airport transfers, office commuting, and outstation trips. Our focus is on punctual service, smooth rides, and affordable pricing across Viman Nagar and Pune city."
    },
    {
        name: "Viman Nagar Cab Service",
        description:
            "Our Viman Nagar Cab Service ensures quick, safe, and convenient transportation for daily commuters, families, and business travelers. Rising Cab Service offers clean vehicles, professional chauffeurs, and flexible booking options for local rides, airport transfers, and intercity travel with complete reliability and comfort."
    },
    {
        name: "Viman Nagar Taxi Service",
        description:
            "Rising Cab Service provides Viman Nagar Taxi Service with comfortable and affordable rides across Pune and Maharashtra. Whether it is a short city trip or a long-distance journey, our experienced drivers ensure safe travel, timely pickup, and smooth travel experience for all passengers."
    },
    {
        name: "Best Cab Service in Viman Nagar",
        description:
            "Book Best Cab Service in Viman Nagar with Rising Cab Service for premium transportation, transparent pricing, and 24x7 support. We offer high-quality service with well-maintained vehicles and professional drivers suitable for families, corporate clients, students, and solo travelers."
    },
    {
        name: "Online Cab Booking Viman Nagar",
        description:
            "Our Online Cab Booking Viman Nagar system allows quick and easy cab reservations with instant confirmation, multiple vehicle options, and transparent pricing. Rising Cab Service ensures a seamless booking experience for both local and outstation travel needs."
    },
    {
        name: "Cab Hire in Viman Nagar",
        description:
            "Rising Cab Service offers Cab Hire in Viman Nagar for hourly rentals, full-day trips, corporate travel, airport transfers, and personal transportation needs. We provide flexible packages with professional drivers and comfortable vehicles for a smooth travel experience."
    },
    {
        name: "Taxi Booking Viman Nagar",
        description:
            "Book Taxi Booking Viman Nagar with Rising Cab Service for fast, reliable, and affordable transportation. We ensure timely service, clean vehicles, and experienced drivers for all types of travel requirements including local and outstation trips."
    },
    {
        name: "Outstation Cab Service Viman Nagar",
        description:
            "Rising Cab Service provides Outstation Cab Service Viman Nagar for long-distance travel to popular destinations like Mumbai, Shirdi, Nashik, Goa, Mahabaleshwar, Kolhapur, Pandharpur, Bhimashankar, and Aurangabad. We offer comfortable rides, experienced drivers, and flexible one-way or round-trip options for safe intercity travel."
    },
    {
        name: "Cab Service Near Phoenix Marketcity Pune",
        description:
            "Rising Cab Service provides Cab Service Near Phoenix Marketcity Pune for shoppers, families, and visitors with quick pickups, safe rides, and reliable transportation before and after mall visits."
    },
    {
        name: "Taxi Service Near Phoenix Mall Pune",
        description:
            "Our Taxi Service Near Phoenix Mall Pune ensures convenient travel for shopping trips, movie visits, and dining experiences with professional drivers and comfortable vehicles."
    },
    {
        name: "Cab Service Near Weikfield IT Park",
        description:
            "Rising Cab Service offers Cab Service Near Weikfield IT Park for IT professionals with timely pickups, safe rides, and reliable office commuting solutions."
    },
    {
        name: "Taxi Service Near Weikfield Pune",
        description:
            "Book Taxi Service Near Weikfield Pune with Rising Cab Service for daily office travel, corporate commuting, and comfortable rides with experienced drivers."
    },
    {
        name: "Cab Service Near Symbiosis Viman Nagar",
        description:
            "Rising Cab Service provides Cab Service Near Symbiosis Viman Nagar for students, staff, and visitors with safe, affordable, and quick transportation options."
    },
    {
        name: "Taxi Service Near Symbiosis College Pune",
        description:
            "Our Taxi Service Near Symbiosis College Pune ensures reliable travel for students and faculty with punctual pickups and comfortable vehicles."
    },
    {
        name: "Cab Service Near Pune Airport",
        description:
            "Rising Cab Service offers Cab Service Near Pune Airport for fast airport transfers with 24x7 availability, clean vehicles, and professional drivers ensuring on-time arrival and pickup."
    },
    {
        name: "Corporate Cab Service Near Viman Nagar",
        description:
            "Book Corporate Cab Service Near Viman Nagar with Rising Cab Service for employee transportation, business travel, and office commuting with reliable and professional service."
    },
    {
        name: "Viman Nagar to Mumbai Cab",
        description:
            "Rising Cab Service provides Viman Nagar to Mumbai Cab for safe and comfortable intercity travel with experienced drivers, smooth highway rides, and flexible booking options."
    },
    {
        name: "Viman Nagar to Shirdi Cab",
        description:
            "Book Viman Nagar to Shirdi Cab with Rising Cab Service for a peaceful pilgrimage journey to Sai Baba temple with clean vehicles and reliable service."
    },
    {
        name: "Viman Nagar to Nashik Cab",
        description:
            "Our Viman Nagar to Nashik Cab service ensures safe and comfortable travel for family trips, pilgrimages, and business journeys with professional drivers."
    },
    {
        name: "Viman Nagar to Goa Cab",
        description:
            "Rising Cab Service provides Viman Nagar to Goa Cab for a relaxing beach vacation with safe driving, comfortable vehicles, and smooth long-distance travel experience."
    },
    {
        name: "Viman Nagar to Mahabaleshwar Cab",
        description:
            "Book Viman Nagar to Mahabaleshwar Cab for scenic hill station travel with experienced chauffeurs and comfortable rides suitable for families and couples."
    },
    {
        name: "Viman Nagar to Lonavala Cab",
        description:
            "Rising Cab Service offers Viman Nagar to Lonavala Cab for quick weekend getaways with safe, affordable, and comfortable transportation."
    },
    {
        name: "Viman Nagar to Kolhapur Cab",
        description:
            "Our Viman Nagar to Kolhapur Cab service ensures smooth pilgrimage and family travel with reliable drivers and well-maintained vehicles."
    },
    {
        name: "Viman Nagar to Pandharpur Cab",
        description:
            "Rising Cab Service provides Viman Nagar to Pandharpur Cab for devotees visiting Lord Vitthal temple with comfortable and safe travel arrangements."
    },
    {
        name: "Viman Nagar to Bhimashankar Cab",
        description:
            "Book Viman Nagar to Bhimashankar Cab for a spiritual Jyotirlinga pilgrimage with safe driving and experienced chauffeurs."
    },
    {
        name: "Viman Nagar to Aurangabad Cab",
        description:
            "Rising Cab Service offers Viman Nagar to Aurangabad Cab for heritage and tourism travel with professional drivers and reliable intercity service."
    },
    {
        name: "Innova Crysta on Rent in Viman Nagar",
        description:
            "Book Innova Crysta on Rent in Viman Nagar with Rising Cab Service for premium comfort, spacious seating, and luxury travel experience ideal for family and group trips."
    }
],

tableData: [
    ["Taxi Service in Viman Nagar", "Viman Nagar Cab Service"],
    ["Viman Nagar Taxi Service", "Best Cab Service in Viman Nagar"],
    ["Online Cab Booking Viman Nagar", "Cab Hire in Viman Nagar"],
    ["Taxi Booking Viman Nagar", "Outstation Cab Service Viman Nagar"],
    ["Cab Service Near Phoenix Marketcity Pune", "Taxi Service Near Phoenix Mall Pune"],
    ["Cab Service Near Weikfield IT Park", "Taxi Service Near Weikfield Pune"],
    ["Cab Service Near Symbiosis Viman Nagar", "Taxi Service Near Symbiosis College Pune"],
    ["Cab Service Near Pune Airport", "Corporate Cab Service Near Viman Nagar"],
    ["Viman Nagar to Mumbai Cab", "Viman Nagar to Shirdi Cab"],
    ["Viman Nagar to Nashik Cab", "Viman Nagar to Goa Cab"],
    ["Viman Nagar to Mahabaleshwar Cab", "Viman Nagar to Lonavala Cab"],
    ["Viman Nagar to Kolhapur Cab", "Viman Nagar to Pandharpur Cab"],
    ["Viman Nagar to Bhimashankar Cab", "Viman Nagar to Aurangabad Cab"],
    ["Innova Crysta on Rent in Viman Nagar"]
],





whychoose: [
    {
        WhyChooseheading: "Premium Cab Services Across Viman Nagar",
        WhyChoosedescription: "Rising Cab Service provides professional transportation solutions for residents, corporate travelers, tourists, and students traveling from Viman Nagar and nearby locations."
    },
    {
        WhyChooseheading: "Fast Airport Connectivity",
        WhyChoosedescription: "Located close to Pune Airport, our cab services offer quick and convenient airport transfers with timely pickups and drop-offs throughout the day."
    },
    {
        WhyChooseheading: "Perfect for Business and Corporate Travel",
        WhyChoosedescription: "Executives, entrepreneurs, and corporate employees rely on our services for meetings, conferences, client visits, and business-related travel requirements."
    },
    {
        WhyChooseheading: "Travel Options for Every Requirement",
        WhyChoosedescription: "Whether you need a local taxi, outstation cab, sightseeing vehicle, weekend getaway ride, or corporate transportation, we have suitable solutions available."
    },
    {
        WhyChooseheading: "Fleet Designed for Comfort and Convenience",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on travel preferences."
    },
    {
        WhyChooseheading: "Coverage Across Pune's Key Locations",
        WhyChoosedescription: "Our services connect Viman Nagar with Kharadi, Hadapsar, Koregaon Park, Magarpatta, Baner, Hinjewadi, Pune Airport, and other major destinations."
    },
    {
        WhyChooseheading: "Professional Service Standards",
        WhyChoosedescription: "Well-groomed drivers, clean vehicles, and efficient trip management ensure a smooth experience for every passenger."
    },
    {
        WhyChooseheading: "Trusted by Frequent Travelers",
        WhyChoosedescription: "Rising Cab Service is preferred by families, working professionals, tourists, and business travelers looking for dependable transportation."
    }
]
};

const faqData = [
    {
        question: "Why do travelers frequently book cabs from Viman Nagar?",
        answer: "Viman Nagar is a major residential, commercial, and hospitality hub with excellent connectivity to Pune Airport and key business districts."
    },
    {
        question: "How convenient is airport travel from Viman Nagar?",
        answer: "Since Viman Nagar is located near Pune Airport, travelers can enjoy quick and hassle-free airport transportation."
    },
    {
        question: "Which nearby locations are commonly served?",
        answer: "Popular destinations include Kharadi, Hadapsar, Koregaon Park, Kalyani Nagar, Magarpatta, Yerwada, and Pune Airport."
    },
    {
        question: "Can business travelers arrange transportation for meetings and events?",
        answer: "Yes, our services are widely used for corporate meetings, conferences, exhibitions, and executive travel."
    },
    {
        question: "What vehicle categories are available for customers?",
        answer: "Customers can select Sedan cars, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and larger vehicles for group travel."
    },
    {
        question: "Are outstation cab services available from Viman Nagar?",
        answer: "Yes, we provide transportation to destinations such as Mumbai, Nashik, Shirdi, Mahabaleshwar, Lonavala, Goa, and many more."
    },
    {
        question: "Can tourists use this service for Pune sightseeing?",
        answer: "Yes, sightseeing packages and city tours can be arranged for visitors exploring Pune and nearby attractions."
    },
    {
        question: "Is it possible to book transportation for family events and functions?",
        answer: "Yes, larger vehicles and group transportation options are available for weddings, celebrations, and family gatherings."
    },
    {
        question: "Do customers have the option of one-way and round-trip travel?",
        answer: "Yes, both travel options are available depending on the planned itinerary."
    },
    {
        question: "What is the booking process for a cab in Viman Nagar?",
        answer: "Customers can reserve a vehicle through a phone call, WhatsApp message, or online inquiry with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rohan Kulkarni",
        feedback:
            "Frequent airport and business travel from Viman Nagar has become much easier with Rising Cab Service. The punctual arrivals and comfortable rides have always been impressive.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Aarti Deshmukh",
        feedback:
            "A family trip arranged through Rising Cab Service exceeded our expectations. Everything was managed efficiently, and the journey remained enjoyable from beginning to end.",
        rating: 5
    }
];












    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Viman Nagar",
"image": "https://www.risingcabservice.com/assets/images/cab-service-in-viman-nagar.jpg",
"description": "Book Cab Service in Viman Nagar with Rising Cab Service for local travel, airport transfers, corporate commuting, and outstation trips. Enjoy safe, affordable, and reliable taxi service near Phoenix Marketcity, Weikfield IT Park, and Symbiosis area.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/cab-service-in-viman-nagar"
}
};








    return (
        <div>

<Helmet>
  <title>Cab Service in Viman Nagar | Airport & Local Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Cab Service in Viman Nagar for airport transfers, local rides, corporate travel, and outstation trips. Reliable taxi service near Phoenix Marketcity, Weikfield IT Park, and Symbiosis area."
/>

<meta
 name="keywords"
 content="Taxi Service in Viman Nagar, Viman Nagar Cab Service, Viman Nagar Taxi Service, Best Cab Service in Viman Nagar, Online Cab Booking Viman Nagar, Cab Hire in Viman Nagar, Taxi Booking Viman Nagar, Outstation Cab Service Viman Nagar, Cab Service Near Phoenix Marketcity Pune, Taxi Service Near Phoenix Mall Pune, Cab Service Near Weikfield IT Park, Taxi Service Near Weikfield Pune, Cab Service Near Symbiosis Viman Nagar"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinvimannagar;